import { saveRoles, getRoles, cleanCache, getRoleCode, savePermissions, saveAccessLevel } from './CacheStorage';
import { checkVersion } from 'src/utils/app-version';

import axios from 'axios';
// Set the common base URL for your API
const baseURL = process.env.REACT_APP_API_URL; //'http://localhost:3030/';
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`
});
const isDebug = process.env.REACT_APP_DEBUG === 'true';

// Set the common base URL for your API
function getRestUrl(endpoint) {
  return `${baseURL}${endpoint}`;
}

// Request interceptor
axiosInstance.interceptors.request.use(
  (response) => {
    // Attach the access token to the request headers
    const accessToken = getAccessToken();
    // if(isDebug){
    //   console.log("Header Token >>>", accessToken);
    // }
    response.headers.Authorization = `Bearer ${accessToken}`;
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    // Check if the error is due to an expired token
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      // Refresh the token
      await fnRefreshToken();
      // Retry the original request with the new token
      return axiosInstance(originalRequest);
    }
    return Promise.reject(error);
  },
);

const fnRefreshToken = async () => {
  // Implement logic to refresh the token using a refresh token
  const refreshData = await auth.refreshToken(); // Use your API call to refresh the token
  const newAccessToken = refreshData.access_token;
  if (newAccessToken) {
    // Save the new access token to storage
    saveAccessToken(newAccessToken);
  } else {
    auth.logout();
  }
};

const saveAccessToken = (accessToken) => {
  // Implement logic to save the access token to storage
  localStorage.setItem('access_token', accessToken);
};
const getAccessToken = () => {
  // Implement logic to retrieve the access token from storage
  return localStorage.getItem('access_token');
};

const saveRefreshToken = (accessToken) => {
  localStorage.setItem('refresh_token', accessToken);
};
const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};

// Simulating an authentication module with a refresh token method
const auth = {
  refreshToken: async () => {
    let accessToken = null;
    try {
      const formData = {
        refresh_token: getRefreshToken(),
        grant_type: 'refresh_token',
      };

      const config = getParams();
      // Make an API call to refresh the token
      const response = await axios.post(
        getRestUrl('auth/refreshToken'),
        formData,
        config,
      );
      if (response) {
        if (200 === response.status) {
          // Extract the new access token from the response
          const json = response.data;
          accessToken = json.accessToken;

          // Check version for reload data
          checkVersion(json.version);
        }
      }
    } catch (error) {
      // Handle the error, e.g., log it or perform appropriate actions
      if(isDebug){
        console.error('Error refreshing token: ', error);
      }
    } finally {
      // if(!accessToken){
      //   throw new Error('Token refreshing error');
      // }
      return {
        access_token: accessToken,
      };
    }
  },
  accessToken: async (queryParams = {}) => {
    let status = false;
    try {
      const linkUrl = getRestUrl('auth/byUserPass');
      const config = getParams(queryParams);
      const response = await axios.post(linkUrl, {}, config);
      printLog('Auth', 'auth/byUserPass', config, response);

      if (response) {
        if (200 === response.status) {
          let json = response.data;
          if (json && json.success) {
            json = json.data;
            if (json) {
              status = true;

              let token = json.accessToken;
              if (token) {
                saveAccessToken(token);
              }
              token = json.refreshToken;
              if (token) {
                saveRefreshToken(token);
              }
              saveRoles(json.roles);
              savePermissions(json.permissions);
              saveAccessLevel(json.accessLevel);
              
              // Check version for reload data
              checkVersion(json.version);
            }
          }
        }
      }
    } catch (error) {
      if(isDebug){
        console.error('Error auth:', error);
      }
      // throw error;
    }
    return status;
  },
  logout: async () => {
    try {
      const linkUrl = getRestUrl('api/user/signout');
      const accessToken = getAccessToken();
      const config = { headers: {} };
      if(accessToken){
        config.headers['authorization'] = `Bearer ${accessToken}`;
      }
      const response = await axios.post(linkUrl, {}, config);
      printLog('Auth', 'api/user/signout', config, response);
    } catch (error) {
      if(isDebug){
        console.error('Error Logout:', error);
      }
    }finally{
      // Clear the stored tokens on logout
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      cleanCache();
    }
  },
  authenticated: () => {
    const token = getAccessToken();
    return token ? true : false;
  },
  userRoles: () => {
    return getRoles();
  },
};

function getParams(queryParams, headers = {}) {
  const headerParams = {
    device_serial: 'Web-Admin',
    role_code: getRoleCode(),
    ...headers
  };

  // const accessToken = getAccessToken();
  // if(accessToken){
  //   headerParams['authorization'] = 'Bearer ' + accessToken;
  // }

  let config = { headers: headerParams };
  if (queryParams) {
    config['params'] = queryParams;
  }
  return config;
}

function printLog(method, endpoint, request, response) {
  if(isDebug){
    let resData = 'Response data empty';
    if (response) {
      resData = response.data;
    }
    const milliseconds = new Date().getTime();
    console.log(
      `${milliseconds}:: API > ${method} > ${endpoint}`,
      '\nReq >',
      JSON.stringify(request, null, 2),
      '\nRes >>',
      JSON.stringify(resData, null, 2),
    );
  }
}

export { axiosInstance, auth, getParams, printLog };
